(() => {
  if (customElements.get('imi-order-updates')) return;
  let pending = false;
  let saved;
  let checkoutLocks = [];
  const components = () => [...document.querySelectorAll('imi-order-updates')];
  const sync = (value, message) => {
    for (const component of components()) {
      component.querySelector('input').checked = value;
      component.querySelector('[role="status"]').textContent = component.dataset[message] || '';
    }
  };
  const lock = () => {
    checkoutLocks = [...document.querySelectorAll('button[name="checkout"], input[name="checkout"]')]
      .map(button => ({button, disabled: button.disabled}));
    for (const {button} of checkoutLocks) button.disabled = true;
    for (const component of components()) component.querySelector('input').disabled = true;
  };
  const unlock = () => {
    for (const {button, disabled} of checkoutLocks) if (button.isConnected) button.disabled = disabled;
    for (const component of components()) component.querySelector('input').disabled = false;
  };
  document.addEventListener('submit', event => {
    if (pending && (event.target.id === 'cart-form' || event.submitter?.name === 'checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  customElements.define('imi-order-updates', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const box = this.querySelector('input');
      if (saved === undefined) saved = box.checked;
      box.checked = saved;
      box.disabled = pending;
      box.addEventListener('change', async () => {
        if (pending) { box.checked = saved; return; }
        const desired = box.checked;
        pending = true;
        lock();
        sync(desired, 'saving');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
            method: 'POST',
            signal: controller.signal,
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({attributes: {imi_whatsapp_order_updates: desired ? 'yes' : 'no'}})
          });
          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();
          if (cart.attributes?.imi_whatsapp_order_updates !== (desired ? 'yes' : 'no')) {
            throw new Error('Cart attribute not saved');
          }
          saved = desired;
          sync(saved, 'saved');
        } catch {
          sync(saved, 'error');
        } finally {
          clearTimeout(timeout);
          pending = false;
          unlock();
        }
      });
    }
  });
})();
